<template>
  <div v-if="posterImageStatus" class="poster-first">
    <div class="poster-pop" v-show="!canvasStatus && posterImage">
      <img
        src="@assets/images/poster-close.png"
        class="close"
        @click="posterImageClose"
      />
      <img
        :src="posterImage"
        ref="conf0"
        alt="tp"
        class="poster-image"
        id="scream"
      />
      <div class="keep">长按图片可以保存到手机</div>
    </div>
    <div class="mask" @touchmove.prevent @click="posterImageClose">
      <div class="canvasBox">
        <canvas ref="myCanvas"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StorePoster",
  props: {
    posterImageStatus: Boolean,
    posterData: Object
  },
  data: function() {
    return {
      canvasStatus: false,
      posterImage: ""
    };
  },
  watch: {
    posterImageStatus: function() {
      let that = this;
      if (that.posterImageStatus === true) {
        that.$nextTick(function() {
          that.savePosterPath();
        });
      }
    }
  },
  mounted: function() {},
  methods: {
   
    posterImageClose: function() {
      this.posterImageStatus = false;
      this.canvasStatus = false;
      this.$emit("setPosterImageStatus");
    },
    savePosterPath: function() {
      this.$dialog.loading.open();
      this.setHtml2Canvas();
    },
    setHtml2Canvas: function() {
      var c = this.$refs.myCanvas;
      var ctx = c.getContext("2d");

      let H = document.body.clientHeight;
      let W = window.innerWidth;
      const pixelRatio = window.devicePixelRatio || 1;
      const backingStoreRatio =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1;
      const ratio = pixelRatio / backingStoreRatio;
      c.width = W * ratio;
      c.height = H * ratio;
      c.style.width = W + "px";
      c.style.height = H + "px";
      ctx.scale(ratio, ratio);

      var imageData = ctx.getImageData(0, 0, c.width, c.height);
      for (var i = 0; i < imageData.data.length; i += 4) {
        // 当该像素是透明的,则设置成白色
        if (imageData.data[i + 3] == 0) {
          imageData.data[i] = 255;
          imageData.data[i + 1] = 255;
          imageData.data[i + 2] = 235;
          imageData.data[i + 3] = 255;
        }
      }
      ctx.putImageData(imageData, 0, 0);

      var img = new Image();
      let imgY = W - 50;
      img.onload = function() {
        ctx.drawImage(img, 0, 0, W, imgY);
      };
      img.src = this.posterData.image;
       console.log(this.posterData)


      ctx.font = "22px PingFang-SC-Medium";
      ctx.fillStyle = "#282828";
      var str = this.posterData.title;
      var initHeight = imgY + 30;
      let fontWidth = ctx.measureText(str).width;
      this.canvasTextAutoLine(str, c, 20, initHeight, 35, W - 20, 2);
      ctx.font = "32px PingFang-SC-Heavy";
      ctx.fillStyle = "#DF2D0A";
      let textY = 0;
      if (fontWidth < W - 20) {
        textY = initHeight + 55;
      } else {
        textY = initHeight + 85;
      }
      ctx.textAlign = "center";
      ctx.fillText("¥：" + this.posterData.price, W / 2, textY);


      var screamsCode = new Image();
      var screamsCode1 = new Image();
     
      let codeY = textY + 20;

      screamsCode.onload = function() {
        ctx.drawImage(screamsCode, 10, codeY, 115, 115);
      };
      screamsCode.src = this.posterData.code;
    

   
      screamsCode1.onload = function() {
        ctx.drawImage(screamsCode1, 170, codeY + 115 / 2+80, 30, 30);
      };
       screamsCode1.src = 'data:image/png;base64,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';      


      ctx.font = "18px Arial";
      ctx.fillStyle = "#282828";
      ctx.textAlign = "left";
      let fontY = codeY + 115 / 2;
      ctx.fillText("长按识别二维码 立即兑换", 135, fontY + 10);
      ctx.fillText("天然之选,品味生活之美", 100, fontY + 130);
      setTimeout(() => {
        this.posterImage = c.toDataURL();
        this.$dialog.loading.close();
      }, 500);
    },
    /**
     * str:要绘制的字符串
     * canvas:canvas对象
     * initX:绘制字符串起始x坐标
     * initY:绘制字符串起始y坐标
     * lineHeight:字行高，自己定义个值即可
     * canvasWidth:文本宽度
     * lines: 行数
     */
    canvasTextAutoLine(
      str,
      canvas,
      initX,
      initY,
      lineHeight,
      canvasWidth,
      lines
    ) {
      var ctx = canvas.getContext("2d");
      var lineWidth = 0;
      var lastSubStrIndex = 0;
      var beginLineHeight = lineHeight;
      var beginY = initY;
      for (let i = 0; i < str.length; i++) {
        lineWidth += ctx.measureText(str[i]).width;
        if (lineWidth > canvasWidth - initX) {
          //减去initX,防止边界出现的问题
          if (initY >= beginY + beginLineHeight * (lines - 1)) {
            ctx.fillText(
              str.substring(lastSubStrIndex, i - 1) + "...",
              initX,
              initY
            );
            return;
          } else {
            ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY);
            initY += lineHeight;
            lineWidth = 0;
            lastSubStrIndex = i;
          }
        }
        if (i == str.length - 1) {
          ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY);
        }
      }
    }
  }
};
</script>
<style scoped>
.poster-first .mask {
  z-index: 1001 !important;
}
.canvasBox {
  width: 100%;
  height: 100%;
  margin: auto;
  /*display: flex;*/
  flex-direction: column;
  justify-content: center;
  align-items: center;

  display: none;
}
.poster-first {
  overscroll-behavior: contain;
}
.poster-pop {
  width: 4.8rem;
  position: fixed;
  left: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  z-index: 9999;
  top: 50%;
  margin-left: -2.4rem;
}
.poster-pop .canvas {
  background-color: #ffffff;
  width: 100%;
}
.poster-pop .poster-image {
  width: 100%;
  display: block;
}
.poster-pop .canvas .image {
  width: 100%;
  height: 4.5rem;
  display: block;
}
.poster-pop .canvas .text {
  text-align: center;
  margin-top: 0.32rem;
}
.poster-pop .canvas .text.black {
  padding: 0 0.1rem;
  color: #000;
}
.poster-pop .canvas .text.rad {
  color: #ff0000;
}
.poster-pop .canvas .code {
  padding: 0 0.1rem 0.2rem 0.1rem;
}
.poster-pop .canvas .code .code-img {
  width: 1.7rem;
  height: 1.7rem;
}
.poster-pop .canvas .code .code-img img {
  width: 100%;
  height: 100%;
}
.poster-pop .canvas .code .code-text {
  width: 2.8rem;
  font-size: 0.24rem;
}
.poster-pop .close {
  width: 0.46rem;
  height: 0.75rem;
  position: fixed;
  right: 0;
  top: -0.75rem;
  display: block;
}
.keep {
  color: #fff;
  text-align: center;
  font-size: 0.25rem;
  margin-top: 0.1rem;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
}
img {
  border: none;
}
</style>
